<template>
    <div id="home-about-app">
        <img class="absolute sky" height="306px" width="45%" src="@/assets/images/main/Vector 15.jpg" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute sky-tablet" height="195px" width="46%" src="@/assets/images/main/Vector 50.png" v-else>
        <img class="absolute bkg-laptop" height="857px" width="90%" src="@/assets/images/main/Vector 9.png" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute bkg-laptop-tablet" height="566px" width="87%" src="@/assets/images/main/Vector 49.png" v-else>
        <img class="absolute laptop" height="754px" width="74%" src="@/assets/images/main/Designlazy_macbook-mockup 1.png" v-if="$vuetify.breakpoint.lgAndUp">
        <img class="absolute laptop-tablet" height="385px" width="71%" src="@/assets/images/main/Designlazy_macbook-mockup 5.png" v-else>
        <img class="absolute rotor-green" height="140.59px" width="10%" src="@/assets/images/main/Rectangle 556.png" :class="{md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
        <img class="absolute rotor-blue" height="170px" width="6%" src="@/assets/images/main/Rectangle 557.png" :class="{md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
        <div id="about-application" class="absolute about-application" :class="{md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
            <div class="flex-center" v-if="$vuetify.breakpoint.lgAndUp">
                <img width="80" src="@/assets/images/logo.svg">
                <div class="logo ml-5">Tasko</div>
                <div class="roboto-bold-36 clr-blue ml-9 pointer z-index-100">О приложении</div>
            </div>
            <div class="flex-center" v-else>
                <img width="50" src="@/assets/images/logo.svg">
                <div class="logo mobile ml-5">Tasko</div>
                <div class="roboto-bold-18 clr-blue ml-10 pointer z-index-100">О приложении</div>
            </div>
            <div class="mt-xl-12 mt-lg-8 pt-xl-8 mt-md-8 mt-sm-8 pr-xl-12 mr-xl-12 pr-lg-12 mr-lg-12 mr-md-12">
                <div class="flex-center">
                    <v-icon large color="light-blue accent-4">mdi-layers-triple</v-icon>
                    <h2 class="ml-8 roboto-bold-24 clr-black-38" v-if="$vuetify.breakpoint.lgAndUp">Заметки: простые и сложные</h2>
                    <h2 class="ml-md-8 ml-sm-4 roboto-bold-18 clr-black-38" v-else>Заметки: простые и сложные</h2>
                </div>
                <div class="mt-xl-7 mt-lg-5 ml-12 pl-5 roboto-normal-24 clr-black-38" v-if="$vuetify.breakpoint.lgAndUp">
                    Вы можете построить в приложении сложную структуру, добавить разделы, подразделы и задачи, а можете создать быструю заметку в один клик, если вам срочно понадобилось что-то записать
                </div>
                <div class="mt-4 ml-12 pl-5 mr-sm-3 roboto-normal-18 clr-black-38" v-if="$vuetify.breakpoint.mdOnly">
                    Вы можете построить в приложении сложную структуру, добавить разделы, подразделы и задачи, а можете создать быструю заметку в один клик, если вам срочно понадобилось что-то записать
                </div>
                <div class="mt-2 ml-12 pl-2 mr-sm-3 roboto-normal-14 clr-black-38" v-if="$vuetify.breakpoint.smOnly">
                    Вы можете построить в приложении сложную структуру, добавить разделы, подразделы и задачи, а можете создать быструю заметку в один клик, если вам срочно понадобилось что-то записать
                </div>
            </div>
            <!-- <div class="mt-xl-12 mt-lg-8 pt-xl-8 mt-md-8 mt-sm-8 pr-xl-12 mr-xl-12 pr-lg-12 mr-lg-12 mr-md-12">
                <div class="flex-center">
                    <v-icon large color="light-blue accent-4">mdi-bell</v-icon>
                    <div class="ml-8 roboto-bold-24 clr-black-38" v-if="$vuetify.breakpoint.lgAndUp">Напоминания и задачи</div>
                    <div class="ml-md-8 ml-sm-4 roboto-bold-18 clr-black-38" v-else>Напоминания и задачи</div>
                </div>
                <div class="mt-xl-7 mt-lg-5 ml-12 pl-5 roboto-normal-24 clr-black-38" v-if="$vuetify.breakpoint.lgAndUp">
                    Вы можете создавать задачи, устанавливать срок исполнения, настраивать уведомления и приложение напомнит вам о самом важном
                </div>
                <div class="mt-4 ml-12 pl-5 mr-sm-4 roboto-normal-18 clr-black-38" v-if="$vuetify.breakpoint.mdOnly">
                    Вы можете создавать задачи, устанавливать срок исполнения, настраивать уведомления и приложение напомнит вам о самом важном
                </div>
                <div class="mt-2 ml-12 pl-2 mr-sm-4 roboto-normal-14 clr-black-38" v-if="$vuetify.breakpoint.smOnly">
                    Вы можете создавать задачи, устанавливать срок исполнения, настраивать уведомления и приложение напомнит вам о самом важном
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeAboutApp',
    data() {
        return {
            
        }
    },
}
</script>

<style lang="scss" scoped>
$clr-black: #000000;
$clr-white: #FFFFFF;
#home-about-app {
    .sky {
        top:872px;
    }
    .sky-tablet {
        top:665px;
    }
    .bkg-laptop {
        top:1043px;
    }
    .bkg-laptop-tablet {
        top:783px;
    }
    .laptop {
        top:985px;
        left:7%;
    }
    .laptop-tablet {
        top:888px;
        left:4%;
    }
    .rotor-green {
        top:903px;
        left:27%;
        &.md, &.sm {
            top:698px;
            height:76px;
        }
    }
    .rotor-blue {
        top:1525px;
        right:6%;
        &.md, &.sm {
            top:1172px;
            right:9%;
            height:80px;
            width:5.5%;
            transform: rotate(-5deg);
        }
    }
    .about-application {
        top:985px;
        left:55%;
        &.md, &.sm {
            top:773px;
            left:50%;
        }
    }
}
</style>